const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const capitalizeAllLetters = (str: string) => {
  return str.toUpperCase();
};

export { capitalizeAllLetters, capitalizeFirstLetter };
